import Header from './layout/header';
import Menu from './layout/menu';
import FileUpload from './file/file-upload';
import FileLinkList from './file/file-link-list';
import ImageUpload from './file/image-upload';
import ImageCarousel from './file/image-carousel';
import formatDateFilter from './filters/format-date-filter';
import formatDatetimeFilter from './filters/format-datetime-filter';
import autofocusMixin from './mixins/autofocus-mixin';
import store from './shared-store';

export default {
  components: [
    Header,
    Menu,
    FileUpload,
    ImageUpload,
    FileLinkList,
    ImageCarousel
  ],

  filters: [formatDateFilter, formatDatetimeFilter],

  mixins: [autofocusMixin],

  store
};



// WEBPACK FOOTER //
// ./src/shared/shared-module.js